/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerFindAllProcessingJobsQueryResponse, DocumentsControllerFindAllProcessingJobsPathParams, DocumentsControllerFindAllProcessingJobs401, DocumentsControllerFindAllProcessingJobs403 } from "../../models/documentsController/DocumentsControllerFindAllProcessingJobs";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentsControllerFindAllProcessingJobs } from "../../clients/documentsService/documentsControllerFindAllProcessingJobs";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentsControllerFindAllProcessingJobsQueryKey = (id: DocumentsControllerFindAllProcessingJobsPathParams["id"], processingId: DocumentsControllerFindAllProcessingJobsPathParams["processingId"]) => [{
  url: '/api/v1/documents/:id/processing/:processingId/jobs',
  params: {
    id: id,
    processingId: processingId
  }
}] as const;
export type DocumentsControllerFindAllProcessingJobsQueryKey = ReturnType<typeof documentsControllerFindAllProcessingJobsQueryKey>;
export function documentsControllerFindAllProcessingJobsQueryOptions(id: DocumentsControllerFindAllProcessingJobsPathParams["id"], processingId: DocumentsControllerFindAllProcessingJobsPathParams["processingId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentsControllerFindAllProcessingJobsQueryKey(id, processingId);
  return queryOptions<DocumentsControllerFindAllProcessingJobsQueryResponse, ResponseErrorConfig<DocumentsControllerFindAllProcessingJobs401 | DocumentsControllerFindAllProcessingJobs403>, DocumentsControllerFindAllProcessingJobsQueryResponse, typeof queryKey>({
    enabled: !!(id && processingId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentsControllerFindAllProcessingJobs(id, processingId, config);
    }
  });
}

/**
 * @summary Get all jobs associated with a processing record
 * {@link /api/v1/documents/:id/processing/:processingId/jobs}
 */
export function useDocumentsControllerFindAllProcessingJobs<TData = DocumentsControllerFindAllProcessingJobsQueryResponse, TQueryData = DocumentsControllerFindAllProcessingJobsQueryResponse, TQueryKey extends QueryKey = DocumentsControllerFindAllProcessingJobsQueryKey>(id: DocumentsControllerFindAllProcessingJobsPathParams["id"], processingId: DocumentsControllerFindAllProcessingJobsPathParams["processingId"], options: {
  query?: Partial<QueryObserverOptions<DocumentsControllerFindAllProcessingJobsQueryResponse, ResponseErrorConfig<DocumentsControllerFindAllProcessingJobs401 | DocumentsControllerFindAllProcessingJobs403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentsControllerFindAllProcessingJobsQueryKey(id, processingId);
  const query = useQuery({
    ...documentsControllerFindAllProcessingJobsQueryOptions(id, processingId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentsControllerFindAllProcessingJobs401 | DocumentsControllerFindAllProcessingJobs403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}